import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { ManageSelfBillingComponent } from './manage-self-billing.component';
import { TableModule } from 'primeng';

const routes: Routes = [
  { path: '', component: ManageSelfBillingComponent, data: { title: 'Self-Billing Agreements' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageSelfBillingRoutingModule {}

@NgModule({
  imports: [
    ManageSelfBillingRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    TableModule,
  ],
  declarations: [ManageSelfBillingComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ManageSelfBillingModule {}
